import { Modal } from 'antd';
import { Button } from '@cropler/ui-kit';
import dayjs from 'dayjs';
import { Trans } from 'react-i18next';

import stylesModal from '../../../styles/modal.module.scss';
import { ModalWidthSmall } from '../../../constants/ui';
import { DateLlFormat } from '../../../constants/data';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const DeleteSeasonModal = ({ t, modalOpen = false, closeModal, editedSeason, onDeleteSeason }) => {
  return (
    <Modal
      title={t('common.areYouSure')}
      open={modalOpen}
      onCancel={closeModal}
      footer={false}
      centered
      width={ModalWidthSmall}
    >
      <p>
        <Trans
          i18nKey="fields.deleteSeason"
          values={{
            name: editedSeason.name ? editedSeason.name.replace(/_/g, ' ') : '',
            period: `${dayjs(editedSeason.sowingDate).format(DateLlFormat)} - ${dayjs(editedSeason.harvestDate).format(DateLlFormat)}`,
          }}
          components={{
            strong: <strong className="text-capitalize" />,
            span: <span className="nowrap" />,
          }}
        />
      </p>
      <div className={stylesModal.modalNav}>
        <Button type="secondary" size={'large'} onClick={closeModal}>
          {t('actions.cancel')}
        </Button>
        <Button type="danger" size={'large'} icon={<CroplerIcon name="remove" />} onClick={onDeleteSeason}>
          {t('actions.delete')}
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteSeasonModal;
